<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "practice"
};
</script>

<style lang="scss"></style>
